define('common/module/asset/Serum.Asset.Fragment',[
  'jquery',
  'common/js/lib/Serum.Pubsub'
], function($, Pubsub){
  'use strict';

  /**
   * @private
   * @constants
   */
  var SERUM_API_ENDPOINT = '/serum/api/render/',
    NEW_LINE = /\r|\n/gi;

  /**
   * @public
   */
  function render(id, $container, params, options) {
    params = params || {};

    options = $.extend({
      replace : false,
      onUpdate : function() {},
      stripWhitespace : true
    }, options || {});

    if ($container) {
      Pubsub.publish(Pubsub.topics.CONTENT_RELOAD, $container.parent());
    }

    // inject content into $surrogate
    var query = $.param(params);
    query = query ? '?' + query : '';

    return $.ajax(SERUM_API_ENDPOINT + id + query)
      .done(function(response) {

        var html = response;
        if (options.stripWhitespace) {
          html = html.replace(NEW_LINE,'');
        }

        var $element = $(html);
        if ($container) {
          if (!options.replace) {
            $container.html($element);
          } else {
            $container.replaceWith($element);
          }
        }

        options.onUpdate($element);

        Pubsub.publish(Pubsub.topics.CONTENT_LOADED);
      })
      .fail(function(error){
        // if an existing item is removed in the CMS the API will respond with 404
        // in that case, the item should be removed from the page if it exists
        // and no error should be reported
        if (error.status === 404 && $container) {
          $container.remove();
        } else {
          Pubsub.publish(Pubsub.topics.CONTENT_DID_FAIL, {
            error:error,
            $container: $container
          });
        }
      });
  }

  /** @interface */
  return {
    render : render
  };


});
